import { render, staticRenderFns } from "./file-parse-format-configuration.vue?vue&type=template&id=f48b04ce&scoped=true&"
import script from "./file-parse-format-configuration.vue?vue&type=script&lang=ts&"
export * from "./file-parse-format-configuration.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f48b04ce",
  null
  
)

export default component.exports